export { default } from './NewsletterRegistrationBlock'
